import { api } from './base'
import type { AuthSessionDto, AuthUserDto, AuthAccountDto } from '../../types/auth'

interface ContractLoginRequest {
  contractNumber: string
  password: string
}

interface CallVerifyRequest {
  phone: string
}

interface CallVerifyStatusResponse {
  status: 'pending' | 'confirmed' | 'expired'
  user?: AuthUserDto
  account?: AuthAccountDto
}

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSession: builder.query<AuthSessionDto, void>({
      query: () => ({ url: '/api/auth/session' }),
    }),
    loginByContract: builder.mutation<AuthSessionDto, ContractLoginRequest>({
      query: (body) => ({ url: '/api/auth/contract', method: 'POST', body }),
    }),
    requestCallVerify: builder.mutation<{ requestId: string }, CallVerifyRequest>({
      query: (body) => ({ url: '/api/auth/call-verify', method: 'POST', body }),
    }),
    checkCallVerify: builder.query<CallVerifyStatusResponse, string>({
      query: (requestId) => ({ url: `/api/auth/call-verify/${requestId}` }),
    }),
    logout: builder.mutation<void, void>({
      query: () => ({ url: '/api/auth/logout', method: 'POST' }),
    }),
  }),
})

export const {
  useGetSessionQuery,
  useLazyGetSessionQuery,
  useLoginByContractMutation,
  useRequestCallVerifyMutation,
  useLazyCheckCallVerifyQuery,
  useLogoutMutation,
} = authApi
